function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Popover } from '../../Popover';
import { Tooltip } from '../../Tooltip';
import { generateUniqueId } from '../../Utils/helper';
import Lock from '@dtsl/icons/dist/icons/react/Lock';
function NavTab(props) {
  const {
    to = '#',
    svg = null,
    title = '',
    target = '_self',
    tooltipData = null,
    popoverData = null,
    locked = false,
    isMobile = false
  } = props;
  const navbarTabClasses = classNames({
    'sib-nav-tab': true,
    'sib-nav-tab__mobile': isMobile
  });
  const onClick = event => {
    if (locked || to === '#') {
      event.stopPropagation();
      event.preventDefault();
      if (locked) return;
    }
    props.onClick(event, tab);
  };
  const tab =
  /*#__PURE__*/
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  React.createElement("a", {
    id: `hdrTab-${generateUniqueId()}`,
    target: target,
    className: navbarTabClasses,
    onClick: onClick,
    href: !locked ? to : '#',
    "aria-label": title || target
  }, /*#__PURE__*/React.createElement("span", {
    className: "sib-nav-tab-label"
  }, locked && !isMobile && /*#__PURE__*/React.createElement(Lock, {
    className: "icon-right"
  }), svg ? /*#__PURE__*/React.cloneElement(svg, {
    className: 'sib-nav-tab-icon'
  }) : null, title));
  if (!isMobile) {
    if (locked && popoverData) {
      return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverData, {
        trigger: ['click']
      }), tab);
    }
    if (tooltipData) {
      return /*#__PURE__*/React.createElement(Tooltip, tooltipData, tab);
    }
  }
  return tab;
}
export default NavTab;
NavTab.propTypes = {
  svg: PropTypes.node,
  to: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  target: PropTypes.string,
  locked: PropTypes.bool,
  helpText: PropTypes.string,
  tooltipData: PropTypes.object,
  isMobile: PropTypes.bool,
  popoverData: PropTypes.object
};